import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useScrollPosition } from '../../hooks/useScrollPosition';

export default function VintageBadge({ scrollProgress }) {
  const scrollPosition = useScrollPosition();
  const heroHeight = window.innerHeight * 0.9; // 90vh (hero height)
  const shouldShow = scrollPosition > heroHeight;

  return (
    <AnimatePresence>
      {shouldShow && (
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ 
            opacity: 1, 
            x: 0,
            scale: [1, 1.1, 1],
            rotate: [-5, 5, 0]
          }}
          exit={{ opacity: 0, x: -20 }}
          transition={{ 
            duration: 0.6,
            scale: {
              duration: 0.8,
              times: [0, 0.5, 1]
            },
            rotate: {
              duration: 0.8,
              times: [0, 0.5, 1]
            }
          }}
          className="hidden lg:block"
        >
          <div className="relative">
            <div 
              className="absolute inset-0 bg-gradient-to-br from-red-500/10 to-amber-500/10 rounded-full blur-xl transition-opacity duration-300"
              style={{ opacity: scrollProgress }}
            />
            <div 
              className="relative px-4 py-1 rounded-full transition-all duration-300"
              style={{
                background: `rgba(255, 255, 255, ${0.8 + scrollProgress * 0.2})`,
                backdropFilter: `blur(${4 + scrollProgress * 4}px)`,
                border: `2px solid rgba(185, 28, 28, ${0.2 + scrollProgress * 0.1})`
              }}
            >
              <span className="text-sm font-semibold text-red-700">
                Siden 1964
              </span>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}